export default __webpack_public_path__ + "static/media/action_required.0530c0af.svg";